
/*----------------------
   SWIPER PRODUCT
---------------------- */
SwiperProduct = {
    init: function () {
        if ($(".swiper-product-images").length) {
            swiperDesktop = new Swiper(".swiper-product-images", {
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: ".main-product__gallery-slider .btn--next",
                    prevEl: ".main-product__gallery-slider .btn--prev",
                },
                pagination: {
                    el: ".main-product__gallery-slider .swiper-pagination",
                    clickable: true,
                },
            });

            swiperMobile = new Swiper(".swiper-product-images-mobile", {
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: ".main-product__gallery-slider.slider-mobile .btn--next",
                    prevEl: ".main-product__gallery-slider.slider-mobile .btn--prev",
                },
                pagination: {
                    el: ".main-product__gallery-slider.slider-mobile .swiper-pagination",
                    clickable: true,
                },
            });
        }
    },
};

/*----------------------
   QUANTITY INPUT
---------------------- */
QuantityControls = {
    init: function () {
        $(document).off("click.quantityControls", ".number-input .quantity__button");
        $(document).on("click.quantityControls", ".number-input .quantity__button", function (e) {
            e.preventDefault();

            var $input = $(this).closest(".number-input").find('input[name="quantity"]');
            if (!$input.length) return;

            var min = parseInt($input.attr("min"), 10) || 1;
            var max = parseInt($input.attr("max"), 10) || null;
            var value = parseInt($input.val(), 10) || min;

            if ($(this).attr("name") === "plus" || $(this).hasClass("plus")) {
                value += 1;
                if (max !== null && !isNaN(max)) value = Math.min(value, max);
            } else {
                value -= 1;
                value = Math.max(value, min);
            }

            $input.val(value).trigger("change");
        });
    },
};

/*----------------------
   STICKY BUY BAR
---------------------- */
StickyBuyBar = {
    observer: null,
    mediaQuery: null,
    onMediaChange: null,

    init: function () {
        var $bar = $(".product-sticky-bar");
        var purchase = document.querySelector(".main-product__purchase");
        var footer = document.querySelector(".section-footer");

        if (!$bar.length || !purchase) return;

        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }

        if (this.mediaQuery && this.onMediaChange) {
            if (this.mediaQuery.removeEventListener) {
                this.mediaQuery.removeEventListener("change", this.onMediaChange);
            } else if (this.mediaQuery.removeListener) {
                this.mediaQuery.removeListener(this.onMediaChange);
            }
        }

        var mq = window.matchMedia("(max-width: 991px)");
        var purchaseVisible = true;
        var footerVisible = false;
        var header = document.querySelector(".section-header");
        var headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 70;

        function updateVisibility() {
            var show = mq.matches && !purchaseVisible && !footerVisible;
            $bar.toggleClass("is-visible", show);
            $bar.attr("aria-hidden", show ? "false" : "true");
        }

        this.observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (entry.target === purchase) {
                        purchaseVisible = entry.isIntersecting;
                    } else if (entry.target === footer) {
                        footerVisible = entry.isIntersecting;
                    }
                });
                updateVisibility();
            },
            {
                threshold: 0,
                rootMargin: "-" + headerHeight + "px 0px 0px 0px",
            }
        );

        this.observer.observe(purchase);
        if (footer) this.observer.observe(footer);

        this.onMediaChange = updateVisibility;
        this.mediaQuery = mq;
        if (mq.addEventListener) {
            mq.addEventListener("change", this.onMediaChange);
        } else if (mq.addListener) {
            mq.addListener(this.onMediaChange);
        }

        $(document)
            .off("change.stickyQty")
            .on(
                "change.stickyQty",
                ".main-product__purchase input[name='quantity'], .product-sticky-bar input[name='quantity']",
                function () {
                    var val = $(this).val();
                    $(
                        ".main-product__purchase input[name='quantity'], .product-sticky-bar input[name='quantity']"
                    )
                        .not(this)
                        .val(val);
                }
            );
    },
};

$(document).ready(function () {
    SwiperProduct.init();
    QuantityControls.init();
    StickyBuyBar.init();
});

$(document).on("shopify:section:load", function () {
    SwiperProduct.init();
    QuantityControls.init();
    StickyBuyBar.init();
});
